export default {
    auth: {
        register: 'Регистрация',
        titleRegistration: 'Cоздать Webitel Аккаунт',
        enterDomain: 'Введите домен',
        enterUsername: 'Введите логин и пароль',
        enterNewUsername: 'Создайте логин и надежный пароль',
        enterLicense: 'Введите лицензионный ключ',
        createAccount: 'Создать аккаунт',
        domain: 'Домен',
        providersTitle: 'Или продолжить с',
        password: 'Пароль',
        confirmPassword: 'Повторите пароль',
        key: 'Ключ',
        registerSubmit: 'Создать',
        signIn: 'Войти',
        login: 'Войти',
    },
};
